// extracted by mini-css-extract-plugin
module.exports = {"label":"_2zPqIbwPGsF2Y_Vh4Al9De","label-container":"Sy1o_MINrWj8N2mryJbJ9","content":"_3OipuyI7vBJJnVt5LQD4Ph"};